<template>
  <Layout>
    <ServerStatusListPage
      title="Approved Applications"
      subtitle="Membership applications that have received final approval."
      card-title="Approved"
      icon="arrow-down-circle"
      tone="emerald"
      by-label="Approved By"
      search-placeholder="Search approved application..."
      empty-message="No approved applications yet"
      endpoint="/applications/approved_applications/"
      :status="status"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import ServerStatusListPage from "@/components/shared/ServerStatusListPage.vue";
import { APPLICATION_STATUS } from "@/constants";

// Shared by staff and admin; paging / search / sort are server-side and kept in the URL.
export default {
  components: {
    Layout,
    ServerStatusListPage,
  },
  data() {
    return { status: APPLICATION_STATUS.APPROVED };
  },
};
</script>